import { FunctionGroup } from '@models/equation-builder';

/**
 * @description Identifier Group that will be auto-selected when user selects the corresponding Function Group.
 */
export const functionGroupsToIdentifiersBindings = [
  { functionGroup: 'Balance sheet Input Data Access Functions', identifierGroup: 'Balance Sheet Mnemonics' },
  { functionGroup: 'Balance sheet Output Data Access Functions', identifierGroup: 'Balance Sheet Mnemonics' },
  { functionGroup: 'Liquidity Source Data Access Functions', identifierGroup: 'Liquidity Sources Mnemonics' },
  { functionGroup: 'Mathematical Functions', identifierGroup: 'Balance Sheet Mnemonics' },
  { functionGroup: 'Logical Functions', identifierGroup: 'Balance Sheet Mnemonics' }
];

/**
 * @description Identifier Group that will be auto-selected when user selects the corresponding Function.
 */
export const functionsToIdentifiersBindings = [
  { function: 'EX(Mn)', identifierGroup: 'Exogenous Mnemonics' },
  { function: 'LUT(Mn)', identifierGroup: 'Lookup Table Mnemonics' }
];

// export const functionGroups: FunctionGroup[] = [
//   {
//     name: 'Balance sheet Input Data Access Functions',
//     functions: [
//       {
//         name: 'AmortCF(Mn)',
//         desc:
//           'Returns Amortization Cashflow balance for a given Mnemonic for a period or for the total amount of several periods',
//         syntax: 'AmortCF (Mnemonic [, Period [, ToPeriod]])',
//         example: 'AmortCF(T_FHLB)'
//       },
//       {
//         name: 'MatuCF(Mn)',
//         desc:
//           'Returns Mature Cashflow balance for a given Mnemonic for a period or for the total amount of several periods',
//         syntax: 'MatuCF (Mnemonic [, Period [,ToPeriod]])',
//         example: 'MatuCF(T_FHLB, 0,2)'
//       },
//       {
//         name: 'PrepayCF(Mn)',
//         desc:
//           'Returns Prepay Cashflow balance for a given Mnemonic for a period or for the total amount of several periods',
//         syntax: 'PrepayCF (Mnemonic [, Period [, ToPeriod]])',
//         example: 'PrepayCF(T_FHLB, -1, 0)'
//       },
//       {
//         name: 'EOPBook(Mn)',
//         desc: 'Returns EOPBook balance for a given Mnemonic for a period or for the total amount of several periods',
//         syntax: 'EOPBook (Mnemonic [, Period [, ToPeriod]])',
//         example: 'EOPBook(T_FHLB, PDNum)'
//       },
//       {
//         name: 'CreditLoss(Mn)',
//         desc:
//           'Returns Credit Loss balance for a given Mnemonic for a period or for the total amount of several periods',
//         syntax: 'CreditLoss (Mnemonic [, Period [, ToPeriod]])',
//         example: 'CreditLoss (T_RESI)'
//       },
//       {
//         name: 'CreditRecovery(Mn)',
//         desc:
//           'Returns Credit Recovery balance for a given Mnemonic for a period or for the total amount of several periods',
//         syntax: 'CreditRecovery (Mnemonic [, Period [,ToPreriod]])',
//         example: 'CreditRecovery(T_RESI)'
//       }
//     ]
//   },
//   {
//     name: 'Balance sheet Output Data Access Functions',
//     functions: [
//       {
//         name: 'StartBal(Mn)',
//         desc: 'Returns Starting Balance for a given Mnemonic for a period or for the total amount of several periods',
//         syntax: 'StartBal (Mnemonic [, Period [,ToPeriod]])',
//         example: 'StartBal (T_FHLB)'
//       },
//       {
//         name: 'NewVol(Mn)',
//         desc: 'Returns New Volume balance for a given Mnemonic for a period or for the total amount of several periods',
//         syntax: 'NewVol (Mnemonic [, Period [,ToPeriod]])',
//         example: 'NewVol (T_RESI)'
//       },
//       {
//         name: 'EndBal(Mn)',
//         desc: 'Returns Ending Balance for a given Mnemonic for a period or for the total amount of several periods',
//         syntax: 'EndBal (Mnemonic [, Period [,ToPeriod]])',
//         example: 'EndBal (T_RESI, 0, 2)'
//       },
//       {
//         name: 'NetSU(Mn)',
//         // tslint:disable-next-line: max-line-length
//         desc:
//           'Returns Sources and Uses balance for a default Mnemonic for a period.\n(The mnemonic TOTALNETSOURCESUSES and TOTALCUMULATIVESOURCESUSES are default Mnemonics which are shown in the Balance Mnemonics identifiers list. )',
//         syntax: 'NetSU (Mnemonic [, Period [,ToPeriod]])',
//         example: 'NetSU (T_RESI, 0, 2)\n\nNetSU (TOTALNETSOURCESUSES, PDNum)\n\nNetSU (TOTALCUMULATIVESOURCESUSES)'
//       },
//       {
//         name: 'Cashflow(Mn)',
//         desc: 'Returns Cash flow balance for a given Mnemonic for a period or for the total amount of several periods',
//         syntax: 'Cashflow (Mnemonic [, Period [,ToPeriod]])',
//         example: 'Cashflow (LT_INVEST)'
//       },
//       {
//         name: 'Rollover(Mn)',
//         desc: 'Returns Rollover balance for a given Mnemonic for a period or for the total amount of several periods',
//         syntax: 'Rollover (Mnemonic [, Period [,ToPeriod]])',
//         example: 'Rollover (T_CLINS, PDNum)'
//       },
//       {
//         name: 'Runoff(Mn)',
//         desc: 'Returns Runoff balance for a given Mnemonic for a period or for the total amount of several periods',
//         syntax: 'Runoff (Mnemonic [, Period [,ToPeriod]])',
//         example: 'Runoff (T_CRE)'
//       },
//       {
//         name: 'Retention(Mn)',
//         desc: 'Returns Retention balance for a given Mnemonic for a period or for the total amount of several periods',
//         syntax: 'Retention (Mnemonic [, Period [,ToPeriod]])',
//         example: 'Retention(T_RETCD)'
//       },
//       {
//         name: 'CommitDraw(Mn)',
//         desc:
//           'Returns Commitment Draw balance for a given Mnemonic for a period or for the total amount of several periods',
//         syntax: 'CommitDraw (Mnemonic [, Period [,ToPeriod]])',
//         example: 'CommitDraw(T_RESI)'
//       }
//     ]
//   },
//   {
//     name: 'Liquidity Source Data Access Functions',
//     functions: [
//       {
//         name: 'TotalAvailable(Type)',
//         desc:
//           'Returns total capacity balance for a liquidity type for a period or for the total amount of several periods',
//         syntax: 'TotalAvailable (Type [, Period [,ToPeriod]])',
//         example: 'TotalAvailable (Primary, PDNum)'
//       },
//       {
//         name: 'TotalRemaining(Type)',
//         desc:
//           'Returns remaining capacity balance for a given Mnemonic for a period or for the total amount of several periods Drawn Capacity',
//         syntax: 'TotalRemaining (Type [, Period [,ToPeriod]])',
//         example: 'TotalRemaining (Secondary, PDNum)'
//       },
//       {
//         name: 'TotalUsed(Type)',
//         desc:
//           'Returns Drawn Capacity balance for a given Mnemonic for a period or for the total amount of several periods Drawn Capacity',
//         syntax: 'TotalUsed (Type [, Period [,ToPeriod]])',
//         example: 'TotalUsed (Tertiary, 2, 6)'
//       },
//       {
//         name: 'LIQ(Mn)',
//         desc: 'Returns the total capacity for a specific liquidity source',
//         syntax: 'LIQ (Mn [, Period [,ToPeriod]])',
//         example: 'LIQ (FHLB_BL)'
//       }
//     ]
//   },
//   {
//     name: 'Support Data Access Functions',
//     functions: [
//       {
//         name: 'EX(Mn)',
//         desc: 'Returns exogenous account values',
//         syntax: 'EX(Mn [, Period [,ToPeriod]])',
//         example: 'EX(Mn)'
//       },
//       {
//         name: 'LUT(Mn)',
//         desc: 'Returns lookup table values',
//         syntax: 'LUT(Mnemonic [, d1 [,d2 [,d3]]])',
//         example: 'LUT( Mn,d1,d2,d3 )'
//       }
//     ]
//   },
//   {
//     name: 'Logical Functions',
//     functions: [
//       {
//         name: 'IF()',
//         desc: 'Returns the result of an IF – THEN logical test',
//         syntax: 'IF( expression, value_if_true [, value_if_false] )',
//         example: 'IF(test, true, false)'
//       },
//       {
//         name: 'AND()',
//         desc: 'Returns TRUE if all of the arguments are true',
//         syntax: 'AND( expression1 [, expression2, expression3, …] )',
//         example: 'AND( PdNum >= 1, PdNum <= 6)'
//       },
//       {
//         name: 'OR()',
//         desc: 'Returns TRUE if any of the logical arguments are true',
//         syntax: 'OR(expression1[, expression2, expression3, …] )',
//         example: 'OR(PdNum = 1, PdNum = 6)'
//       },
//       { name: 'TRUE()', desc: 'Returns the logical TRUE condition', syntax: 'TRUE()', example: 'TRUE()' },
//       {
//         name: 'INLIST()',
//         desc: 'Returns the logical TRUE condition if first variable given is found in the list of variables.',
//         syntax: 'InList( test_value, compare1, compare2,... )',
//         example: 'InList(v, x1, x2, x3, ...,xn)'
//       },
//       { name: 'FALSE()', desc: 'Returns the logical FALSE condition', syntax: 'FALSE()', example: 'FALSE()' }
//     ]
//   },
//   {
//     name: 'Mathematical Functions',
//     functions: [
//       {
//         name: 'ABS (number)',
//         desc: 'Returns the absolute value of a number',
//         syntax: 'ABS( num )',
//         example: 'ABS( 12.5 )'
//       },
//       {
//         name: 'MIN (Num1, Num2)',
//         desc: 'Returns the minimum value from a list',
//         syntax: 'MIN( num1, num2 [, num3,...] )',
//         example: 'MIN(2, 5)'
//       },
//       {
//         name: 'MAX (Num1, Num2)',
//         desc: 'Returns the maximum value from a list',
//         syntax: 'MAX( num1, num2 [, num3,...] )',
//         example: 'MAX(2, 5)'
//       },
//       {
//         name: 'MROUND (number, multiple)',
//         desc: 'Returns a number rounded to the nearest desired multiple',
//         syntax: 'MROUND( num, multiple )',
//         example: 'MROUND(123.456, 0.25) = 123.5'
//       },
//       {
//         name: 'MROUNDDOWN (number, multiple)',
//         desc: 'Returns a number rounded DOWN to the nearest desired multiple',
//         syntax: 'MROUNDDOWN( num, multiple )',
//         example: 'MROUNDDOWN(17,3) = 15'
//       },
//       {
//         name: 'MROUNDUP (number, multiple)',
//         desc: 'Returns a number rounded UP the nearest desired multiple',
//         syntax: 'MROUNDUP( num, multiple )',
//         example: 'MROUNDUP(16,3) = 18\nand MROUNDUP(1.55,0.25) = 1.75'
//       }
//     ]
//   }
// ];
